/**
 * The way in to documents and spreadsheets in items: their viewers and editor are a chunk of their own (`Documents.tsx`,
 * with the formula engine, Quill, Pretext and the rest), loaded the first time an item's file is one.
 */

import { lazy } from "../lib/lazy.ts";

export type DocumentsModule = typeof import("./Documents.tsx");

/** The chunk (tests swap it). */
export const documentsChunk: { load: () => Promise<DocumentsModule> } = {
  load: lazy(() => import("./Documents.tsx")),
};
